// O painel lateral do grafo, portado de graph.js:454-504.
//
// Ele é a mesma informação do desenho em forma de lista, e é por isso que o
// canvas anuncia "P abre o painel com a mesma informação em texto": quem usa
// leitor de tela não vê o grafo, mas rota, hub e órfão são texto.
import {
  KIND, lateralDeCobertura, lateralDeCodigo, lateralDeMemoria,
  type GrafoBruto, type ItemLateral, type Modo,
} from './nucleo';

interface Props {
  grafo: GrafoBruto | null;
  memoria: GrafoBruto | null;
  modo: Modo;
  aoEscolher: (chave: string) => void;
  aoFechar: () => void;
}

function Item({ item, aoEscolher }: { item: ItemLateral; aoEscolher: (k: string) => void }) {
  const n = item.no;
  return (
    <button className="g-item" type="button" onClick={() => aoEscolher(n.node_key)}>
      <i className="kdot" style={{ background: `var(${KIND[n.kind] || '--ink-faint'})` }} />
      {String(n.label || n.node_key).replace(/^pkg:/, '')}
      {item.extra ? <span className="n">{item.extra}</span> : null}
    </button>
  );
}

const Lista = ({ itens, vazio, aoEscolher }: {
  itens: ItemLateral[]; vazio: string; aoEscolher: (k: string) => void;
}) => (itens.length
  ? <>{itens.map((i) => <Item key={i.no.node_key} item={i} aoEscolher={aoEscolher} />)}</>
  : <div className="empty-line">{vazio}</div>);

export function Lateral({ grafo, memoria, modo, aoEscolher, aoFechar }: Props) {
  const fechar = (
    <button className="g-close" type="button" title="fechar painel" onClick={aoFechar}>×</button>
  );

  if (modo === 'memoria') {
    const d = lateralDeMemoria(grafo, memoria?.totals);
    return (
      <div className="g-side show">
        {fechar}
        <h5>Cobertura do acervo</h5>
        <div className="g-item">
          <i className="kdot" style={{ background: 'var(--ok)' }} />
          arquivos com memória<span className="n">{d.arquivosComMemoria}/{d.arquivos}</span>
        </div>
        <h5>A confirmar · {d.totalAConfirmar}</h5>
        <Lista itens={d.aConfirmar} vazio="nada pendente de confirmação" aoEscolher={aoEscolher} />
        <h5>Deriva · {d.totalDeriva}</h5>
        <Lista itens={d.deriva} vazio="nenhum texto cita código inexistente" aoEscolher={aoEscolher} />
        <h5>Lacunas abertas · {d.totalLacunas}</h5>
        <Lista itens={d.lacunas} vazio="nenhuma lacuna aberta" aoEscolher={aoEscolher} />
      </div>
    );
  }

  if (modo === 'cobertura') {
    const d = lateralDeCobertura(grafo);
    const corDoPct = d.pct >= 50 ? '--ok' : d.pct >= 20 ? '--warn' : '--bad';
    return (
      <div className="g-side show">
        {fechar}
        <h5>O que o time escreveu</h5>
        <div className="g-item">
          <i className="kdot" style={{ background: `var(${corDoPct})` }} />
          arquivos com memória<span className="n">{d.pct}%</span>
        </div>
        <h5>Ninguém escreveu · {d.totalVazios}</h5>
        <Lista itens={d.vazios} vazio="todo arquivo tem alguma memória" aoEscolher={aoEscolher} />
        <h5>Mais documentados</h5>
        <Lista itens={d.ricos} vazio="nada documentado ainda" aoEscolher={aoEscolher} />
      </div>
    );
  }

  const d = lateralDeCodigo(grafo);
  return (
    <div className="g-side show">
      {fechar}
      <h5>Rotas HTTP · {d.totalRotas}</h5>
      <Lista itens={d.rotas} vazio="nenhuma rota no AST" aoEscolher={aoEscolher} />
      <h5>Mais dependidos</h5>
      <Lista itens={d.hubs} vazio="sem relações extraídas" aoEscolher={aoEscolher} />
      <h5>Arquivos sem relação · {d.orfaos.length}</h5>
      <Lista itens={d.orfaos} vazio="todos os arquivos estão conectados" aoEscolher={aoEscolher} />
    </div>
  );
}
